import { queryShiyiCompany } from '@/services/company';

export default {
  namespace: 'ChainBrandStoreCompanies',
  state: {
    data: {},
  },
  effects: {
    *queryShiyiCompany({ payload }, { call, put }) {
      const { status, data } = yield call(queryShiyiCompany, payload);

      if (status === 200) {
        yield put({
          type: 'save',
          payload: {
            list: data.data.items,
            pagination: {
              total: data.data.meta.total,
              pageSize: data.data.meta.per_page,
              current: data.data.meta.current_page,
            },
          },
        });
      }
    },
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        data: payload,
      };
    },
  },
};
